import React, { PropTypes } from 'react'
import FlagList from '../flag-list'
import userFlags from '../../fieldOptions/userFlags'

const UserFlags = ({ flags, ...props }) => (
  // @ts-ignore
  <FlagList
    flags={userFlags}
    value={flags}
    {...props}
  />
)

// @ts-ignore
UserFlags.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

// @ts-ignore
UserFlags.defaultProps = {
  value: {}
}

export default UserFlags
